import React from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react'

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams()
  const projectId = searchParams.get('project_id')

  return (
    <div className="font-['Inter'] min-h-screen bg-[#FAFAF7] text-[#0A0F0D] flex items-center justify-center">

      <div className="relative bg-white rounded-3xl border border-[#E5E7EB] p-6 sm:p-12 max-w-lg w-full mx-4 my-8 shadow-md">
        <div className="text-center">
          {/* Cancel Icon */}
          <div className="w-20 h-20 bg-white border border-[#E5E7EB] rounded-2xl flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-[#B45309]" />
          </div>

          {/* Title */}
          <h1 className="text-2xl sm:text-3xl font-bold mb-4">Betaling geannuleerd</h1>

          {/* Message */}
          <p className="text-[#0A0F0D] text-base sm:text-lg mb-8">
            Je betaling is geannuleerd. Je project is opgeslagen als concept en kan later worden gepubliceerd na betaling van de aanbetaling.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4">
            {projectId && (
              <Link
                to={`/projects/${projectId}/payment`}
                className="w-full px-6 py-4 bg-[#3EB489] hover:bg-[#359E78] rounded-xl font-semibold transition flex items-center justify-center gap-2 text-white"
              >
                <CreditCard className="w-5 h-5" />
                Probeer Opnieuw
              </Link>
            )}

            <Link
              to="/my-projects"
              className="w-full px-6 py-4 bg-white border border-[#E5E7EB] hover:border-[#0A0F0D] hover:bg-[#FAFAF7] rounded-xl font-semibold transition flex items-center justify-center gap-2 text-[#0A0F0D]"
            >
              <ArrowLeft className="w-5 h-5" />
              Naar Mijn Projecten
            </Link>
          </div>

          {/* Info */}
          <div className="mt-8 pt-6 border-t border-[#E5E7EB]">
            <p className="text-sm text-[#64748B]">
              Geen zorgen! Je kunt altijd later terugkomen om je project te publiceren.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentCancelPage
